export default __webpack_public_path__ + "static/young-toddler1-b06b42485275a597bcbc395892749477.jpg";